 import { GetOrdersInvoicesDtResponse } from "~/types/backend";
import {

  GET_ORDERS_INVOICES_DT,
  GET_ORDERS_INVOICES_DT_OK,
  GET_ORDERS_INVOICES_DT_ERR,
  DO_ORDERS_INVOICES_DT_CLEANUP,

  APPLY_ORDERS_INVOICES_DT_FILTERS,
  PATCH_ORDERS_INVOICES_DT_FILTERS,
  CLEAR_ORDERS_INVOICES_DT_FILTERS,
  UNSET_ORDERS_INVOICES_DT_FILTERS,
} from "./actionTypes";
import { TListParams } from "~/types/global";
import { TDtFiltersState } from "./type";

/********** DATATABLE **********/

export const getOrdersInvoicesDt = (params: TListParams) => ({
  type: GET_ORDERS_INVOICES_DT,
  payload: { params },
});

export const getOrdersInvoicesDtOk = (response: GetOrdersInvoicesDtResponse) => ({
  type: GET_ORDERS_INVOICES_DT_OK,
  payload: { response },
});

export const getOrdersInvoicesDtErr = (error: Error) => ({
  type: GET_ORDERS_INVOICES_DT_ERR,
  payload: { error },
});

export const doOrdersInvoicesDtCleanup = () => ({
  type: DO_ORDERS_INVOICES_DT_CLEANUP,
});

/********** DATATABLE FILTERS **********/

export const applyOrdersInvoicesDtFilters = (filters: TDtFiltersState) => ({
  type: APPLY_ORDERS_INVOICES_DT_FILTERS,
  payload: { filters },
});

export const patchOrdersInvoicesDtFilters = (filters: TDtFiltersState) => ({
  type: PATCH_ORDERS_INVOICES_DT_FILTERS,
  payload: { filters },
});

export const clearOrdersInvoicesDtFilters = () => ({
  type: CLEAR_ORDERS_INVOICES_DT_FILTERS,
});

export const unsetOrdersInvoicesDtFilters = () => ({
  type: UNSET_ORDERS_INVOICES_DT_FILTERS,
});